import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "group w-32 h-32 border-4 border-transparent border-solid relative mx-auto rounded-full overflow-hidden" }
const _hoisted_2 = {
  key: 0,
  class: "absolute z-20 top-0 left-0 w-full h-full bg-cebai-base-dark opacity-50 flex flex-col justify-center items-center rounded-full transition text-cebai-base-light"
}
const _hoisted_3 = { class: "w-8 h-8" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "mt-1 uppercase text-xs" }, "Upload", -1)
const _hoisted_6 = {
  ref: "fileInputEl",
  class: "block invisible",
  type: "file",
  accept: "image/*"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingIcon = _resolveComponent("LoadingIcon")!
  const _component_CameraIcon = _resolveComponent("CameraIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isUploading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_LoadingIcon, { class: "fill-current" })
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        ref: "dropzoneEl",
        class: _normalizeClass(["block relative z-10 border-4 border-dashed transition rounded-full overflow-hidden", {
        'border-cebai-base-dark': _ctx.isHovered,
        'border-transparent': !_ctx.isHovered,
      }]),
        type: "button",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleUploadImage && _ctx.handleUploadImage(...args)), ["prevent"]))
      }, [
        _createElementVNode("img", {
          class: "relative z-10 w-28 h-28 object-cover",
          src: _ctx.user.picture,
          alt: ""
        }, null, 8, _hoisted_4),
        _createElementVNode("div", {
          class: _normalizeClass(["group-hover:opacity-80 absolute z-20 top-0 left-0 w-full h-full bg-cebai-base-dark transition flex flex-col justify-center items-center text-cebai-base-light", {
          'opacity-80': _ctx.isHovered,
          'opacity-0': !_ctx.isHovered,
        }])
        }, [
          _createVNode(_component_CameraIcon, { class: "fill-current" }),
          _hoisted_5
        ], 2)
      ], 2)
    ]),
    _createElementVNode("input", _hoisted_6, null, 512)
  ], 64))
}